import axios from 'axios';

export async function uploadAttachmentFile(url, fields, file)  {
    const formData = new FormData();
    formData.append('Content-Type', file.type);

    formData.append('Content-Disposition', `inline; filename="${file.name}"`);
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));
    formData.append('file', file);

    return axios.post(url, formData)
        .then(d => d.data)
        .catch(error => {
            throw error;
        });
}

export const uploadDocument = async (url, fields, file, type = 'attachment', onUploadProgress) => {
    const formData = new FormData();
    formData.append('Content-Type', file.type);

    formData.append('Content-Disposition', `${type}; filename="${file.name}"`);
    Object.entries(fields).forEach(([k, v]) => formData.append(k, v));
    formData.append('file', file);

    return axios.post(url, formData, {
        onUploadProgress: (progressEvent) => {
            const progress = (progressEvent.loaded / progressEvent.total) * 100;

            if (onUploadProgress) {
                onUploadProgress(progress);
            }
        },
    })
        .then(d => d.data)
        .catch(error => {
            throw error;
        });
};
